import { render, staticRenderFns } from "./ChallengeEntities.vue?vue&type=template&id=058ce16f&scoped=true&lang=pug&"
import script from "./ChallengeEntities.vue?vue&type=script&lang=js&"
export * from "./ChallengeEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ce16f",
  null
  
)

export default component.exports